/* unplugin-vue-components disabled */import script from "./banner.vue?vue&type=script&lang=jsx"
export * from "./banner.vue?vue&type=script&lang=jsx"

import "./banner.vue?vue&type=style&index=0&id=573ec4ac&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-573ec4ac"]])

export default __exports__